import { AUTH_TOKEN_KEY } from '../constants';
export const clearLocalStorage = () => {
    console.log('local clean');
    localStorage.clear();
};
export const setLocalStorageAuthToken = (token) => {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
};
export const getLocalStorageAuthToken = () => {
    try {
        return localStorage.getItem(AUTH_TOKEN_KEY);
    }
    catch (e) {
        // logger.error(e);
    }
    return null;
};
//# sourceMappingURL=localStorage.js.map